import tinycolor from 'tinycolor2';

import './Branding.css';

type BrandingProps = {
	primaryColor: string;
	secondaryColor: string;
	isRootStyles?: boolean;
};

function getColors({ primaryColor, secondaryColor }: BrandingProps) {
	const primary = tinycolor(primaryColor);
	const primaryLighten = tinycolor.mix(primary, 'white', 15);
	const secondary = tinycolor(secondaryColor);
	const secondaryLighten = tinycolor.mix(secondary, 'white', 15);

	// If white text is unreadable on the lighen 15% color (too light) - switch to darken 15%
	// readablity is determined by WCAG guidelines
	// https://github.com/bgrins/TinyColor#isreadable
	return {
		brandPrimaryColor: primaryColor,
		brandPrimaryColorHover: tinycolor.isReadable('#fff', primaryLighten, { level: 'AAA', size: 'small' })
			? primaryLighten.toHexString()
			: tinycolor.mix(primary, 'black', 15).toHexString(),
		brandSecondaryColor: secondaryColor,
		brandSecondaryColorAlt: tinycolor.isReadable('#fff', secondaryLighten, { level: 'AAA', size: 'small' })
			? secondaryLighten.toHexString()
			: tinycolor.mix(secondary, 'black', 15).toHexString(),
	};
}

export function Branding({ primaryColor, secondaryColor, isRootStyles }: BrandingProps) {
	const { brandPrimaryColor, brandPrimaryColorHover, brandSecondaryColor, brandSecondaryColorAlt } = getColors({
		primaryColor,
		secondaryColor,
	});
	return (
		<style>
			{`${isRootStyles ? ':root' : ':host'} {
				--primary-color: ${brandPrimaryColor};
				--primary-color-hover: ${brandPrimaryColorHover};
				--secondary-color: ${brandSecondaryColor};                
				--secondary-color-alt: ${brandSecondaryColorAlt}; 
				--font-family: Inter, sans-serif;               
				--base-font-size: 16px;            
				--base-text-color: #4B4D53;            
			}`}
		</style>
	);
}
